/**
 * @generated SignedSource<<6fe08205f56e471e0661a6f351a80661>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type profanityRuleEditor_ProfanityFilterRuleDetailQuery$variables = {
  id: string;
};
export type profanityRuleEditor_ProfanityFilterRuleDetailQuery$data = {
  readonly profanityFilterRule: {
    readonly enableImageModeration: boolean;
    readonly enableTextFilter: boolean;
    readonly id: string;
    readonly lang: string;
    readonly langDetection: boolean;
    readonly moderationCategories: ReadonlyArray<{
      readonly moderationCategoryID: number;
      readonly moderationCategoryTypeID: number;
      readonly name: string | null;
      readonly value: string | null;
    }>;
    readonly name: string;
    readonly printTypes: ReadonlyArray<{
      readonly printTypeID: number;
    } | null> | null;
    readonly products: ReadonlyArray<{
      readonly productID: number;
    }>;
    readonly profanityFilterRuleID: number;
  } | null;
};
export type profanityRuleEditor_ProfanityFilterRuleDetailQuery = {
  response: profanityRuleEditor_ProfanityFilterRuleDetailQuery$data;
  variables: profanityRuleEditor_ProfanityFilterRuleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProfanityFilterRule",
    "kind": "LinkedField",
    "name": "profanityFilterRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profanityFilterRuleID",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableTextFilter",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableImageModeration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "langDetection",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lang",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ModerationCategory",
        "kind": "LinkedField",
        "name": "moderationCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moderationCategoryID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moderationCategoryTypeID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfanityFilterRuleProduct",
        "kind": "LinkedField",
        "name": "products",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfanityFilterRulePrintType",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "printTypeID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "profanityRuleEditor_ProfanityFilterRuleDetailQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "profanityRuleEditor_ProfanityFilterRuleDetailQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bd8479c0915399cd611e9a9c789b14af",
    "id": null,
    "metadata": {},
    "name": "profanityRuleEditor_ProfanityFilterRuleDetailQuery",
    "operationKind": "query",
    "text": "query profanityRuleEditor_ProfanityFilterRuleDetailQuery(\n  $id: ID!\n) {\n  profanityFilterRule(id: $id) {\n    id\n    profanityFilterRuleID\n    name\n    enableTextFilter\n    enableImageModeration\n    langDetection\n    lang\n    moderationCategories {\n      moderationCategoryID\n      moderationCategoryTypeID\n      value\n      name\n    }\n    products {\n      productID\n    }\n    printTypes {\n      printTypeID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6df68421cd25cd060a6303b1837286d";

export default node;
